module.exports = __webpack_public_path__ + "img/caijiqi02.fb2a620a.png";